/* @flow */
import React from 'react';
import Button from 'components/Button.jsx';
import './styles/BoxButton.scss';

class BoxButton extends React.Component {
  static propTypes = {
    text: React.PropTypes.string,
  };

  render() {
    const { children, text, ...rest } = this.props;
    return (
      <Button {...rest} className="BoxButton" full eventElementName="BoxButton">
        {text}
        {children}
      </Button>
    );
  }
}

export default BoxButton;



// WEBPACK FOOTER //
// ./src/components/BoxButton.jsx